<div
  class="relative w-full bg-white px-5.75 py-6"
  [ngClass]="{
    'max-w-113': config.secondButton,
    'max-w-100': !config.secondButton,
  }"
>
  @if (config.showCloseButton) {
    <div class="flex justify-end">
      <button mat-dialog-close class="cursor-pointer">
        <img src="icons/close_icon.svg" alt="Cerrar" class="w-6 h-6" />
      </button>
    </div>
  }

  <div class="flex flex-col space-y-4 items-center">
    <div class="mb-4.5 flex justify-center">
      <div class="flex items-center justify-center rounded-full" [style.color]="getIconColor()">
        @switch (config.type) {
          @case ('success') {
            <mat-icon svgIcon="success-icon" class="h-8.5! w-8.5!"></mat-icon>
          }
          @case ('error') {
            <mat-icon svgIcon="error-icon" class="h-8.5! w-8.5!"></mat-icon>
          }
          @case ('info') {
            <mat-icon svgIcon="info-icon" class="h-8.5! w-8.5!"></mat-icon>
          }
          @case ('alert') {
            <mat-icon svgIcon="alert-icon" class="h-8.5! w-8.5!"></mat-icon>
          }
        }
      </div>
    </div>

    <h2
      class="mb-2 text-center text-[18px] font-bold text-th-black"
      [ngClass]="{
        'mb-2': config.description,
        'mb-7.5': !config.description,
      }"
    >
      {{ config.title }}
    </h2>

    @if (config.description) {
      <p class="mb-7.5 text-center text-base font-normal text-black whitespace-pre-wrap">
        {{ config.description }}
      </p>
    }

    @if (config.secondButton) {
      <div class="flex w-full gap-4 justify-center">
        <button
          (click)="onButtonClick()"
          class="flex-1 min-h-12 max-w-46.25 text-[16px] cursor-pointer rounded-[3px] border border-th-blue px-3 py-3 font-semibold text-th-blue transition-colors"
        >
          {{ config.buttonText }}
        </button>
        <button
          (click)="onSecondButtonClick()"
          class="flex-1 min-h-12 max-w-46.25 text-[16px] cursor-pointer rounded-[3px] bg-th-blue px-3 py-3 font-semibold text-white transition-colors"
        >
          {{ config.secondButton.text }}
        </button>
      </div>
    } @else {
      <button
        (click)="onButtonClick()"
        class="min-w-75 min-h-12 text-[16px] cursor-pointer rounded-[3px] bg-th-blue px-6 py-3 font-semibold text-white transition-colors"
      >
        {{ config.buttonText }}
      </button>
    }
  </div>
</div>
